module.exports = __webpack_public_path__ + "img/logo2.9fc00927.png";